import React, { forwardRef } from "react";
import { Switch } from "antd";
import { SwitchProps } from "antd/lib/switch";

export interface SwitchWithLabelProps extends SwitchProps {
  label: string;
  onChange?: (checked: boolean) => void;
}

const SwitchWithLabel = forwardRef<any, SwitchWithLabelProps>(
  (
    {
      label,
      checked = false,
      onChange,
      disabled = false,
      size = "default",
      className = "",
      style = {},
      ...switchProps
    },
    ref
  ) => {
    const handleLabelClick = () => {
      if (!disabled && onChange) {
        onChange(!checked);
      }
    };

    const handleSwitchChange = (checked: boolean) => {
      if (onChange) {
        onChange(checked);
      }
    };

    return (
      <div className={className} style={style}>
        <Switch
          {...switchProps}
          ref={ref}
          checked={checked}
          onChange={handleSwitchChange}
          disabled={disabled}
          size={size}
        />
        <span
          style={{
            paddingLeft: 10,
            ...(disabled && {
              color: "rgba(0, 0, 0, 0.25)",
              cursor: "not-allowed",
            }),
          }}
          onClick={handleLabelClick}
        >
          {label}
        </span>
      </div>
    );
  }
);

SwitchWithLabel.displayName = "SwitchWithLabel";

export default SwitchWithLabel;
